import Listeners from '@/plugins/sdk/Listeners'

export default class {
  /**
   * Constructs the object.
   *
   * @param      {Resource}  resource  The resource to listen against
   * @param      {Array}     events    The events to listen for
   * @param      {Function}  callback  The callback
   */
  constructor (resource, events, callback) {
    if (!Array.isArray(events)) {
      events = [ events ]
    }

    Object.defineProperties(this, {
      resource: {
        configurable: false,
        enumerable: false,
        value: resource,
        writable: false
      },
      events: {
        configurable: false,
        enumerable: false,
        value: Object.freeze(events),
        writable: false
      },
      callback: {
        configurable: false,
        enumerable: false,
        value: callback,
        writable: false
      }
    })

    Listeners.register(this)

    return Object.freeze(this)
  }

  /**
   * Destroy the event listener.
   */
  destroy () {
    Listeners.deregister(this)
  }
}
